import styled from "styled-components";
import { Link as LinkS } from "react-router-dom";

export const NavMenu = styled.ul`
	list-style: none;
	text-align: left;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: stretch;
	align-items: flex-start;

	h2 {
		font-size: var(--fontMed);
		color: var(--lightGrey);
		font-weight: 500;
	}
`;

export const NavItem = styled.li`
	display: flex;
	justify-content: flex-start;
	align-items: stretch;
`;

export const Navlinks = styled(LinkS)`
	position: relative;
	text-decoration: none;
	cursor: pointer;
	display: inline-block;

	h3 {
		font-size: var(--fontSmall);
		color: var(--lightGrey);
		font-weight: 500;
		margin-top: 18px;
	}

	:before {
		position: absolute;
		content: "";
		width: 100%;
		height: 2px;
		bottom: -2px;
		left: 0;
		background-color: var(--lightGrey);
		visibility: hidden;
		transform: scaleX(0);
		transition: all 0.3s ease-in-out 0s;
	}

	:hover:before {
		visibility: visible;
		transform: scaleX(1);
	}
`;
